import React from "react";
import { Link } from "react-router-dom";
import "./PrivacyPolicyPage.css";

// Privacy Policy Icons
function ShieldIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    </svg>
  );
}

function DatabaseIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <ellipse cx="12" cy="5" rx="9" ry="3"/>
      <path d="M3 5v14c0 1.66 4.03 3 9 3s9-1.34 9-3V5"/>
      <path d="M3 12c0 1.66 4.03 3 9 3s9-1.34 9-3"/>
    </svg>
  );
}

function EyeIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
      <circle cx="12" cy="12" r="3"/>
    </svg>
  );
}

function LockIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
      <circle cx="12" cy="16" r="1"/>
      <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
    </svg>
  );
}

function UsersIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
      <circle cx="9" cy="7" r="4"/>
      <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
      <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
    </svg>
  );
}

function CheckCircleIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
      <polyline points="22,4 12,14.01 9,11.01"/>
    </svg>
  );
}

function BrainIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96.44 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-6.58 2.5 2.5 0 0 1 1.32-4.24 2.5 2.5 0 0 1 1.98-3A2.5 2.5 0 0 1 9.5 2Z"/>
      <path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96.44 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-6.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-1.98-3A2.5 2.5 0 0 0 14.5 2Z"/>
    </svg>
  );
}

function HeartIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
    </svg>
  );
}

export default function PrivacyPolicyPage() {
  return (
    <div className="mariamly-privacy-policy-page">
      {/* Banner Section */}
      <div className="policy-banner">
        <div className="policy-banner-content">
          <h1 className="policy-banner-title">Privacy Policy</h1>
          <div className="policy-breadcrumb">
            <Link to="/">Home</Link>
            <span>/</span>
            <span>Privacy Policy</span>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="policy-content">
        {/* Introduction Section */}
        <div className="policy-intro">
          <div className="intro-content">
            <h2>Privacy Policy – Mariamly Luxe</h2>
            <p className="intro-lead">
              At Mariamly Luxe, your privacy and trust are our top priorities. This Privacy Policy explains how we collect, use, and protect your information when you shop with us or use our AI-powered beauty recommendation feature.
            </p>
          </div>
          <div className="intro-image">
            <div className="image-placeholder">
              <ShieldIcon size={48} color="#d19e90" />
            </div>
          </div>
        </div>

        {/* Information We Collect Section */}
        <div className="policy-section">
          <div className="section-header">
            <div className="section-icon">
              <DatabaseIcon size={40} />
            </div>
            <h3>1. Information We Collect</h3>
          </div>
          <div className="section-content">
            <p className="section-intro">When you use our website or AI tool, we may collect:</p>
            <div className="policy-points">
              <div className="policy-point">
                <CheckCircleIcon size={24} />
                <div className="point-content">
                  <strong>Personal Information:</strong> such as your name, email, shipping address, and payment details (for order processing).
                </div>
              </div>
              <div className="policy-point">
                <BrainIcon size={24} />
                <div className="point-content">
                  <strong>Skin/Hair/Beauty Preferences:</strong> details you provide to our AI assistant (e.g., skin type, hair concerns, shade preferences) to recommend suitable products.
                </div>
              </div>
              <div className="policy-point">
                <EyeIcon size={24} />
                <div className="point-content">
                  <strong>Technical Data:</strong> including IP address, browser type, and device information to improve your shopping experience.
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* How We Use Your Information Section */}
        <div className="policy-section">
          <div className="section-header">
            <div className="section-icon">
              <UsersIcon size={40} />
            </div>
            <h3>2. How We Use Your Information</h3>
          </div>
          <div className="section-content">
            <div className="policy-points">
              <div className="policy-point">
                <CheckCircleIcon size={24} />
                <p>To process and deliver your orders.</p>
              </div>
              <div className="policy-point">
                <BrainIcon size={24} />
                <p>To provide personalized recommendations through our AI beauty assistant.</p>
              </div>
              <div className="policy-point">
                <HeartIcon size={24} />
                <p>To send you exclusive offers, updates, and promotions (only if you opt in).</p>
              </div>
              <div className="policy-point">
                <EyeIcon size={24} />
                <p>To improve our website, products, and services.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Data Protection Section */}
        <div className="policy-section">
          <div className="section-header">
            <div className="section-icon">
              <LockIcon size={40} />
            </div>
            <h3>3. Data Protection</h3>
          </div>
          <div className="section-content">
            <div className="policy-points">
              <div className="policy-point">
                <ShieldIcon size={24} />
                <p>All personal data is stored securely and protected against unauthorized access.</p>
              </div>
              <div className="policy-point">
                <LockIcon size={24} />
                <p>Payment information is encrypted and processed through trusted, secure payment gateways—we do not store full credit card details.</p>
              </div>
              <div className="policy-point">
                <BrainIcon size={24} />
                <p>AI recommendations are generated based only on the information you choose to share.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Sharing Your Information Section */}
        <div className="policy-section">
          <div className="section-header">
            <div className="section-icon">
              <UsersIcon size={40} />
            </div>
            <h3>4. Sharing Your Information</h3>
          </div>
          <div className="section-content">
            <div className="policy-points">
              <div className="policy-point">
                <ShieldIcon size={24} />
                <p>We never sell your personal information to third parties.</p>
              </div>
              <div className="policy-point">
                <CheckCircleIcon size={24} />
                <p>Data may only be shared with trusted service providers (e.g., shipping companies, payment processors) strictly for order fulfillment.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Your Rights Section */}
        <div className="policy-section">
          <div className="section-header">
            <div className="section-icon">
              <CheckCircleIcon size={40} />
            </div>
            <h3>5. Your Rights</h3>
          </div>
          <div className="section-content">
            <p className="section-intro">You have the right to:</p>
            <div className="policy-points">
              <div className="policy-point">
                <EyeIcon size={24} />
                <p>Request access to the personal information we hold about you.</p>
              </div>
              <div className="policy-point">
                <CheckCircleIcon size={24} />
                <p>Request correction or deletion of your data.</p>
              </div>
              <div className="policy-point">
                <HeartIcon size={24} />
                <p>Opt out of marketing communications at any time.</p>
              </div>
            </div>
          </div>
        </div>

        {/* AI Disclaimer Section */}
        <div className="policy-section ai-disclaimer">
          <div className="section-header">
            <div className="section-icon">
              <BrainIcon size={40} />
            </div>
            <h3>6. AI Disclaimer</h3>
          </div>
          <div className="section-content">
            <div className="ai-notice">
              <BrainIcon size={32} />
              <p>
                Our AI beauty assistant provides recommendations only and does not replace professional medical or dermatological advice. Customers are responsible for ensuring products are suitable for their personal use.
              </p>
            </div>
            <div className="policy-points" style={{ marginTop: '20px' }}>
              <div className="policy-point">
                <CheckCircleIcon size={24} />
                <div className="point-content">
                  <strong>Detailed AI Policy:</strong> For comprehensive information about our Ask Mariamly AI chatbot, including image protection, data usage, and AI limitations, please review our <Link to="/ask-mariamly-policy" style={{ color: '#d19e90', textDecoration: 'none', fontWeight: '600' }}>Ask Mariamly AI Policy</Link>.
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Policy Updates Section */}
        <div className="policy-section">
          <div className="section-header">
            <div className="section-icon">
              <ShieldIcon size={40} />
            </div>
            <h3>7. Policy Updates</h3>
          </div>
          <div className="section-content">
            <p>
              Mariamly Luxe may update this Privacy Policy from time to time. Any changes will be posted on this page with the updated date.
            </p>
          </div>
        </div>

        {/* Agreement Section */}
        <div className="agreement-section">
          <div className="agreement-content">
            <div className="agreement-icon">
              <HeartIcon size={32} />
            </div>
            <div className="agreement-text">
              <h4>✨ By using our website and AI features, you agree to the terms of this Privacy Policy.</h4>
            </div>
          </div>
        </div>

        {/* Contact Information */}
        <div className="contact-section">
          <div className="contact-content">
            <h3>Questions About Our Privacy Policy?</h3>
            <p>
              If you have any questions about our privacy practices or need assistance with your data, our customer service team is here to help.
            </p>
            <div className="contact-buttons">
              <Link to="/contact" className="contact-button primary">
                <HeartIcon size={20} />
                <span>Contact Us</span>
              </Link>
              <Link to="/shop" className="contact-button secondary">
                <CheckCircleIcon size={20} />
                <span>Shop Now</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
